var openModal;
(function (openModal_1) {
    const $links = document.querySelectorAll('a');
    const $modals = document.querySelectorAll('.modal.taxonomy-term');
    if ($links && $modals) {
        function openModal() {
            $links.forEach($link => {
                $link.addEventListener(('click'), (e) => {
                    const $hrefAttribute = $link.getAttribute('href').replace('/', '');
                    $modals.forEach($modal => {
                        if ($modal.getAttribute('id') == $hrefAttribute) {
                            e.preventDefault();
                            $modal.classList.add('is-open');
                        }
                    });
                });
            });
        }
        function closeModal() {
            $modals.forEach($modal => {
                const $closeBtn = $modal.querySelector('.close-btn');
                $closeBtn.addEventListener(('click'), () => {
                    clearForm($modal);
                    $modal.classList.remove('is-open');
                });
                $modal.addEventListener('click', function (e) {
                    const $clickedBox = document.getElementById('clickable');
                    if (!$clickedBox.contains(e.target)) {
                        clearForm($modal);
                        $modal.classList.remove('is-open');
                    }
                });
            });
        }
        function clearForm($modal) {
            const $form = $modal.querySelector('form.to-complete');
            const $email = $modal.querySelector('input[type="email"]');
            const $inputs = $modal.querySelectorAll('input[type="text"]');
            const $warning = $modal.querySelector('.error-banner');
            const $selects = $modal.querySelectorAll('.custom-select-opener');
            $selects.forEach($select => {
                $select.classList.remove('has-error');
            });
            $email.classList.remove('has-error');
            $inputs.forEach($input => {
                $input.classList.remove('has-error');
            });
            $warning.classList.remove('has-error');
            $form.reset();
        }
        function validate() {
            $modals.forEach($modal => {
                const $confirmBtn = $modal.querySelector('.btn');
                const deliveryAddress = $modal.getAttribute('data-email-address');
                $confirmBtn.addEventListener(('click'), (e) => {
                    var _a;
                    e.preventDefault();
                    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/gi;
                    let isValid = true;
                    const $email = $modal.querySelector('.required input[type="email"]');
                    const $inputs = $modal.querySelectorAll('.required input[type="text"]');
                    const $selects = $modal.querySelectorAll('label.required');
                    const $warning = $modal.querySelector('.error-banner');
                    const title = $modal.querySelector('.title .field--name-field-title p');
                    $selects.forEach($select => {
                        const $tempSelect = $select.querySelector('select');
                        const $customSelect = $select.querySelector('.custom-select-opener');
                        if ($customSelect) {
                            if ($tempSelect.options[$tempSelect.selectedIndex].value == 'default') {
                                isValid = false;
                                $customSelect.classList.add('has-error');
                            }
                            else {
                                $customSelect.classList.remove('has-error');
                            }
                        }
                    });
                    $inputs.forEach($input => {
                        const $tempInput = $input;
                        if ($tempInput.value == '') {
                            $input.classList.add('has-error');
                            isValid = false;
                        }
                        else {
                            $input.classList.remove('has-error');
                        }
                    });
                    if ((regex.test($email.value))) {
                        $email.classList.remove('has-error');
                    }
                    else {
                        $email.classList.add('has-error');
                        isValid = false;
                    }
                    if (!isValid) {
                        $warning.classList.add('has-error');
                        e.preventDefault();
                    }
                    else {
                        $warning.classList.remove('has-error');
                        let body = '';
                        (_a = Array.from($modal.querySelectorAll('.label-title'))) === null || _a === void 0 ? void 0 : _a.forEach((label) => {
                            let parentElement = label.parentElement;
                            let currentValue = $modal.querySelector(`#${parentElement.getAttribute('for')}`);
                            body += `${label.innerText}: ${currentValue.value}%0D%0A`;
                        });
                        window.location.href = `mailto:${deliveryAddress}?subject=${title.innerText}&body=${body}`;
                    }
                });
            });
        }
        function init() {
            openModal();
            closeModal();
            validate();
        }
        init();
    }
})(openModal || (openModal = {}));
